import { mergeStyles } from "@fluentui/merge-styles";

export const categoryTab = (active: boolean, muted: boolean = false) => mergeStyles({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--druid-gap-8)',
    padding: 'var(--druid-space-6) var(--druid-space-12)',
    paddingLeft: 'calc(var(--druid-space-12) + var(--webchat-editor-tab-indicator-size))',
    color: active ? 'var(--druid-color-text-primary)' : muted ? 'var(--druid-color-text-disabled)' : 'var(--druid-color-text-secondary)',
    fontSize: 'var(--druid-font-size-xl)',
    fontWeight: active ? 'var(--druid-font-weight-semibold)' : 'var(--druid-font-weight-normal)',
    textAlign: 'left',
    cursor: 'pointer',
    transition: 'color var(--druid-transition-fast) ease',
    selectors: {
        ':before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 'var(--webchat-editor-tab-indicator-inset)',
            bottom: 'var(--webchat-editor-tab-indicator-inset)',
            width: 'var(--webchat-editor-tab-indicator-size)',
            borderRadius: 'var(--webchat-editor-tab-indicator-radius)',
            backgroundColor: active ? 'var(--druid-color-success-primary)' : 'transparent',
            transition: 'background-color var(--druid-transition-fast) ease',
        },
        ':hover': active ? {} : {
            color: 'var(--druid-color-text-primary)',
        },
        ':focus-visible': {
            outline: '2px solid var(--druid-button-focus-border)',
            outlineOffset: '-2px',
        },
    },
});

// Search result count shown at the end of a category link.
export const categoryTabCount = mergeStyles({
    marginLeft: 'auto',
    minWidth: 20,
    padding: '0 var(--druid-space-6)',
    borderRadius: 'var(--webchat-editor-tab-indicator-radius)',
    backgroundColor: 'var(--druid-green-100)',
    color: 'var(--druid-green-700)',
    fontSize: 'var(--druid-font-size-sm)',
    fontWeight: 'var(--druid-font-weight-semibold)',
    lineHeight: '20px',
    textAlign: 'center',
});
